import type { FC } from 'react';
import { appI18n } from '@flowus/common/i18n';

import { useLogin } from '../../../hook/use-login';
import { Button } from '../../../uikit/web/button';
import { Input } from '../../../uikit/web/input';
import { md5Sum, Regex } from '../../../utils';
import { loginInjector } from '../../../utils/init';

interface VerifyPasswordProps {
  userId: string;
  onSuccess: (authorizationCode: string) => void;
}
export const VerifyPasswordCode: FC<VerifyPasswordProps> = (props) => {
  const { userId, onSuccess } = props;
  const { password, setPassword, passwordError, setPasswordError } = useLogin();

  const tryVerifySmsCode = async () => {
    if (!Regex.Password.test(password)) {
      setPasswordError(appI18n.t('pkg_login.password_incorrect') as string);
      return;
    }
    const res = await loginInjector.request.infra.passwordAuthorization.raw({
      uuid: userId,
      password: md5Sum(password),
    });
    if (res.code === 200) {
      if (res.data.authorizationCode) {
        onSuccess(res.data.authorizationCode);
        setPasswordError(appI18n.t('pkg_login.verify_fail') as string);
      }
    } else {
      setPasswordError(res.msg);
    }
  };

  return (
    <div className="next-modal pt-10 pb-5 px-7 flex flex-col items-center min-w-[400px]">
      <div className="mb-5 text-t1-medium">{appI18n.t('pkg_login.verify_password')}</div>
      <Input
        autoFocus
        inputType="password"
        value={password}
        className="mb-10 w-full"
        placeholder={appI18n.t('pkg_login.input_current_password') as string}
        inputClassName="px-3 h-8 text-t2"
        onEnter={() => void tryVerifySmsCode()}
        warning={passwordError}
        onChange={(v) => setPassword(v.toString())}
      />
      <Button
        disable={!password}
        className="text-t2 h-8"
        size="auto"
        onClick={() => void tryVerifySmsCode()}
      >
        {appI18n.t('pkg_login.next_step')}
      </Button>
    </div>
  );
};
